module.exports = __webpack_public_path__ + "static/img/contact_weixin.fa9d7b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/contact_weixin.jpg
// module id = HOLI
// module chunks = 11